const SharingEditing = Object.freeze({
  PRIVATE: 'PRIVATE',
  SHARED_WITH_ANALYSTS: 'SHARED_WITH_ANALYSTS'
})
export default SharingEditing
// RESERVE BELOW
